import(/* webpackMode: "eager" */ "/app/main/app/[locale]/ai-learn/list/supervised/page.tsx");
